import { trackMetric } from './Telemetry.js'

/**
 * Billing / Chargebee funnel. The `*_success` events fire when the user returns from Chargebee, so
 * `checkout_initiated` → `checkout_success` is the trial→paid conversion funnel and
 * `recharge_initiated` → `recharge_success` is the usage-credit funnel.
 */
export type BillingAction = 'checkout_initiated' | 'checkout_success' | 'recharge_initiated' | 'recharge_success' | 'manage_subscription'

export const trackBilling = (action: BillingAction, extra: Record<string, string | number | boolean> = {}): void => {
  trackMetric('billing.action', { action, ...extra })
}
